import { render, staticRenderFns } from "./EditStructure.vue?vue&type=template&id=0ffd0226&"
import script from "./EditStructure.vue?vue&type=script&lang=ts&"
export * from "./EditStructure.vue?vue&type=script&lang=ts&"
import style0 from "./EditStructure.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports